import { useState } from "react";

export interface FaqEntry {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqEntry[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-50 md:px-6 md:py-5"
              >
                <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                  {item.q}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-5 md:px-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}